import { Badge, formatPrice, timestampFormatter } from '@retainerclub/common';
import PropTypes from 'prop-types';

function DashboardTransactionsTableRow({ transaction }) {
  function getStatusColor(status) {
    switch (status) {
      case 'successful':
      case 'complete':
        return 'green';
      case 'failed':
        return 'red';
      default:
        return 'gray';
    }
  }

  return (
    <tr>
      <td className="flex w-full flex-col justify-start gap-4 py-8 pr-3 pl-4 font-medium text-gray-900 text-sm sm:w-auto sm:max-w-none sm:flex-row sm:items-center sm:pl-0">
        <div>
          <span className="font-normal">
            {transaction.transactionId}
            <br />
            {transaction.accountCreditCard
              ? `${transaction.accountCreditCard.brand} ${transaction.accountCreditCard.maskedNumber.replace('************', '**** ')}`
              : 'Unknown'}
          </span>
          <dl className="font-normal lg:hidden">
            <dt className="sr-only">Amount</dt>
            <dd className="mt-1 truncate text-gray-700">
              {formatPrice(transaction.amountApproved || transaction.total)}
            </dd>
            <dt className="sr-only sm:hidden">Purchase</dt>
            <dd className="mt-1 truncate text-gray-500 sm:hidden">
              {transaction?.order && (
                <p>
                  Order:{' '}
                  <span className="uppercase">{transaction.order.hexCode}</span>
                </p>
              )}
              {transaction?.subscription && (
                <p>
                  Subscription:{' '}
                  <span className="uppercase">
                    {transaction.subscription.hexCode}
                  </span>
                </p>
              )}
            </dd>
            <dt className="sr-only">Date</dt>
            <dd className="mt-1 truncate text-gray-500">
              {timestampFormatter(transaction.createdAt, false)}
            </dd>
          </dl>
        </div>
        <div>
          <Badge
            name={
              typeof transaction?.state === 'string'
                ? transaction.state.split('_').join(' ')
                : ''
            }
            withDot={false}
            size="sm"
            color={getStatusColor(transaction?.state ?? 'unknown')}
          />
        </div>
      </td>

      <td className="hidden px-3 py-8 text-gray-500 text-sm sm:table-cell">
        {formatPrice(transaction.amountApproved || transaction.total)}
      </td>
      <td className="hidden px-3 py-8 text-gray-500 text-sm sm:table-cell">
        {transaction?.order && (
          <p>
            Order:{' '}
            <span className="uppercase">{transaction.order.hexCode}</span>
          </p>
        )}
        {transaction?.subscription && (
          <p>
            Renewal:{' '}
            <span className="uppercase">
              {transaction.subscription.hexCode}
            </span>
            <br />
            {transaction.subscription.patient.firstName}{' '}
            {transaction.subscription.patient.lastName}
          </p>
        )}
      </td>
      <td className="hidden px-3 py-8 text-gray-500 text-sm sm:table-cell">
        {timestampFormatter(transaction.createdAt, false)}
      </td>
    </tr>
  );
}

DashboardTransactionsTableRow.propTypes = {
  transaction: PropTypes.object.isRequired,
};

export default DashboardTransactionsTableRow;
